module.exports = __webpack_public_path__ + "static/media/hero-broker.54cfa6ef.jpg";